import { Messages } from '../../codegen/Localize';
import { IWorkbookBase } from '../models/IWorkbookInfo';
import { Module } from '../Module';
import { Workbooks } from '../resources/Workbooks';
import { IResult } from '../ServerApi/types/IResponse';
import { ToasterService, ToastType } from './ToasterService';
import { WorkbookErrors } from './WorkbookErrors';

export class ChangeWorkbookDescriptionAction {

  public static $inject = [ 'Workbooks', 'WorkbookErrors'];

  constructor(
    private Workbooks: Workbooks,
    private WorkbookErrors: WorkbookErrors) { }

  public execute(workbook: IWorkbookBase, newDescription: string): ng.IPromise<IResult> {

    return this.Workbooks.setDescription(workbook.id, newDescription).then((result: IResult) => {
      if (result.errors && result.errors.length) {
        ToasterService.instance.pop({
          type: ToastType.Error,
          text: this.WorkbookErrors.errorMessageFor({ item: workbook, error: result.errors[0] })
        });
      } else {
        ToasterService.instance.pop({ type: ToastType.Success, text: Messages.editDescriptionSuccessful() });
      }
      return result;
    });

  }

}

Module.instance().service('ChangeWorkbookDescriptionAction', ChangeWorkbookDescriptionAction);
